import { JourneyType } from '@bytel/leviator';

import { MobilePlanType } from '@app-types/plan';
import { SimulatedCartProduct } from '@app-types/product';

import { MarketingType } from '@constants/plan';

export function getSimulatedPhone(
    simulatedCart?: SimulatedCartProduct,
    phoneGencode?: string,
    quoteType = JourneyType.MOBILE_ACQUISITION,
) {
    return simulatedCart?.quotes?.find((q) => q.type === quoteType)?.products.find((el) => el.gencode === phoneGencode);
}

export function getPlanName(offer?: MobilePlanType, customName?: string) {
    if (!offer) {
        return null;
    }
    if (customName) {
        return customName;
    }
    const isMultiline = offer.details.discounts.find((discount) =>
        discount.marketingTypes.includes(MarketingType.MULTILINE),
    );
    if (isMultiline) {
        return offer.shortDescription;
    }

    return `Forfait ${offer.shortDescription}`;
}
